import React from 'react';
import ScreenHeader from '../components/ScreenHeader';
import Display from '../components/Display';
import useSWR from 'swr';
import { localAxios } from '../api';


function Approved() {

  const { isLoading } = useSWR('/api/me', localAxios);

  if (isLoading) {
    return (
      <div className="app-wide__container">
        <ScreenHeader message="Visitor Training Tracker" />
        <div className="app-wide__add-new" />
        <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
          <p>Loading...</p>
        </div>
        <div className="app-wide__footer" />
      </div>
    );
  }

  return (
    <div className="app-wide__container">
      <ScreenHeader message="Visitor Training Tracker" />
      <div className="app-wide__add-new" />
      <div className="app-wide__main approved__main">
        <Display message="Your visitors have been approved! The submission has been recorded." />
        <p className="approved__note">You may now close this browser page.</p>
      </div>
      <div className="app-wide__footer" />
    </div>
  );
}

export default Approved;
